// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.kyc.bizum.description.';

const KYC_BIZUM_DESCRIPTIONS = {
  description_01: `${DOMAIN}verify`,
  description_02: `${DOMAIN}noCharges`,
};

export { KYC_BIZUM_DESCRIPTIONS };
